import './Cookies.css'
import React from 'react';
import Cookies from 'js-cookie';
import {useCookies} from "@/contexts/CookiesContext";
import Redirects from "@/commons/utils/Redirects"

const CookiesPage = () => {
    let whitelistedPages = ["file"]
    const {accepted, acceptedAnalytics} = useCookies();

    const handleAccept = () => {
        Cookies.set('cookiesAccepted', String(true), {expires: 30, path: '/'});
        Cookies.set('cookiesAnalytics', String(true), {expires: 30, path: '/'});
        window.location.reload();
    };

    function handleDecline() {
        Cookies.set('cookiesAccepted', String(true), {expires: 30, path: '/'});
        Cookies.set('cookiesAnalytics', String(false), {expires: 30, path: '/'});
        window.location.reload();
    }

    if (accepted === true) {
        return null; // Non mostra il banner cookies per le pagine whitelisted
    } else {
        // Controlla se la pagina attuale è nella lista delle pagine consentite
        if (whitelistedPages.includes(window.location.pathname.toLowerCase().split("/")[1])) {
            return null; // Non mostra il banner cookies per le pagine whitelisted
        }

        return (
            <>
                <div className="cookies">
                    <div>
                        <p>
                            Questo sito utilizza cookie tecnici e, previo consenso, cookie di analisi (Google Analytics)
                            per raccogliere dati statistici anonimi. Per maggiori informazioni, leggi i nostri
                            <a onClick={() => {
                                Redirects.domainSendNewPage("www", "tos");
                            }}> Termini di Servizio</a> e <a href="/privacy">Privacy Policy</a>.
                        </p>
                    </div>
                    <div>
                        <button onClick={handleAccept}>Accetta tutti</button>
                        <button onClick={handleDecline}>Solo tecnici</button>
                    </div>
                </div>
            </>
        )
    }
};

export default CookiesPage;